import { render } from "./SaveSalaryComponent.vue?vue&type=template&id=1e6ddcda&scoped=true"
import script from "./SaveSalaryComponent.vue?vue&type=script&lang=js"
export * from "./SaveSalaryComponent.vue?vue&type=script&lang=js"

import "./SaveSalaryComponent.vue?vue&type=style&index=0&id=1e6ddcda&lang=scss&scoped=true"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e6ddcda"]])

export default __exports__